import $ from 'jquery';

const requestSafetyDataSheet = () => {
    const $requestForm = $('#request-safety-datasheet');

    if ($requestForm.length === 0) return;

    $requestForm.each(() => {
        const $nameField = $('input[name="rsds-field-name"]', this);
        const $surnameField = $('input[name="rsds-field-surname"]', this);
        const $companyNameField = $(
            'input[name="rsds-field-company-name"]',
            this
        );
        const $productName = $('input[name="rsds-field-product-name"]', this);
        const $address = $('input[name="rsds-field-address"]', this);
        const $email = $('input[name="rsds-field-email"]', this);
        const $phoneNumber = $('input[name="rsds-field-phone-number"]', this);
        const $textField = $('textarea[name="rsds-field-message"]', this);
        const $countryField = $('select.rsds-field-country', this);
        const $submitBtn = $('button.rsds__submit', this);

        const submitSubscription = () => {
            let hasError = false;

            const fields = [
                $nameField,
                $surnameField,
                $companyNameField,
                $productName,
                $address,
                $email,
                $phoneNumber,
                $countryField,
                $textField
            ];

            fields.forEach(field => {
                if (!field) return;

                const isEmpty = !(field && field.val() && !!field.val().length);

                if (isEmpty) {
                    field.parent().addClass('Error');
                    hasError = true;
                    return;
                }

                if (field.hasClass('rsds-field-country')) {
                    field
                        .parent()
                        .parent()
                        .find('span.EditingFormErrorLabel')
                        .remove();

                    return;
                }
 
                field.parent().removeClass('Error');
            });

            if (!hasError) {
                $submitBtn.addClass('is-loading');
            }
        };

        $submitBtn.on('click', submitSubscription);
    });
};

// doc ready
$(() => {
    requestSafetyDataSheet();
});